const localBackend = import.meta.env.VITE_REACT_APP_LOCAL_BACKEND as boolean;
const development = {
  aws: {
    Auth: {
      Cognito: {
        identityPoolId: 'eu-west-1:46ef19b7-823a-4c10-a0a6-fa23d303688e',
        userPoolId: 'eu-west-1_ZQAKufUVZ',
        userPoolClientId: '1t2j35i84uj8ekvr29np02n9k7',
      },
    },
    Storage: {
      S3: {
        bucket: 'wawi-dev',
        region: 'eu-west-1',
      },
    },
  },
  cookie: {
    domain: window.location.hostname,
    secure: false,
  },
  //api: 'http://localhost:4000/wawi/graphql',
  api: 'https://dev.api.hssoft.com/wawi/graphql',
  consoleApi: 'https://api.hssoft.com/console/graphql',
  alternativeGuid: true,
  muiLicenseKey:
    'cf51365c771fbeba6dfe82da76e3102dTz0xMjA5MzUsRT0xNzkyOTcyNzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
};

if (localBackend) {
  development.api = 'http://localhost:4000/wawi/graphql';
}

const production = {
  aws: {
    Auth: {
      Cognito: {
        identityPoolId: 'eu-west-1:46ef19b7-823a-4c10-a0a6-fa23d303688e',
        userPoolId: 'eu-west-1_ZQAKufUVZ',
        userPoolClientId: '1t2j35i84uj8ekvr29np02n9k7',
      },
    },
    Storage: {
      S3: {
        bucket: 'wawi-prod',
        region: 'eu-west-1',
      },
    },
  },
  cookie: {
    domain: '.hssoft.com',
    secure: true,
  },
  api: 'https://api.hssoft.com/wawi/graphql',
  consoleApi: 'https://api.hssoft.com/console/graphql',
  alternativeGuid: false,
  muiLicenseKey:
    'cf51365c771fbeba6dfe82da76e3102dTz0xMjA5MzUsRT0xNzkyOTcyNzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
  modules: {
    customer: {
      page: true,
      components: null,
    },
    article: {
      page: true,
      components: null,
    },
    order: {
      page: true,
      components: {
        createOrder: true,
        editOrder: true,
        orderOverview: true,
      },
    },
    offer: {
      page: true,
      components: null,
    },
    production: {
      page: true,
      components: {
        printJobs: true,
        editPrintList: true,
        stockOfFreezer: true,
        toolboxExport: true,
      },
    },
    invoice: {
      page: true,
      components: {
        createInvoice: true,
        invoiceList: true,
      },
    },
    debitor: {
      page: true,
      components: {
        openDebts: true,
        payments: true,
        importIso: true,
      },
    },
    statistic: {
      page: true,
      components: {
        orderStatistic: true,
        productionStatistic: true,
      },
    },
    settings: {
      page: true,
      components: null,
    },
    layout: {
      page: true,
      components: {
        assistant: true,
        expertMode: true,
      },
    },
  },
};

const staging = {
  ...production,
  api: 'https://25lckn5n7d.execute-api.eu-west-1.amazonaws.com/wawi/graphql',
};
export const environment = { development, production, staging };
